import type { APlusData } from '../types';

export type APlusServiceLineItem = { sku: string; selected: true };

export const getAplusDataForBasket = (aPlusData: APlusData | null) => {
  if (!aPlusData) {
    return undefined;
  }

  const selectedServices: APlusServiceLineItem[] = [];

  aPlusData.values().forEach(({ item, selected }) => {
    if (selected) {
      selectedServices.push({ sku: item.uuid, selected: true });
    }
  });

  return selectedServices;
};
